var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-codemirror",class:{'link-codemirror-readonly':_vm.readonly}},[_c('div',{ref:"target",staticClass:"link-codemirror-target"})])}
var staticRenderFns = []

export { render, staticRenderFns }